(function () {
  'use strict';

  var overlay = document.getElementById('drawer-overlay');
  var drawers = {
    nav: document.getElementById('drawer-nav'),
    cart: document.getElementById('drawer-cart')
  };

  if (!overlay || (!drawers.nav && !drawers.cart)) return;

  var openName = null;
  var lastTrigger = null;
  var savedScrollY = 0;

  var focusableSel = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  function isVisible(el) {
    return el.offsetParent !== null || el === document.activeElement;
  }

  function getFocusable(drawer) {
    return Array.prototype.filter.call(
      drawer.querySelectorAll(focusableSel),
      isVisible
    );
  }

  // Mobile-safe scroll lock. Plain overflow:hidden on <body> causes iOS
  // Safari to reflow the page's horizontal layout (left-edge cropping).
  // The fix: anchor the page with position:fixed + top:-scrollY, then
  // restore the exact scroll position on close.
  function lockBody() {
    savedScrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.top = '-' + savedScrollY + 'px';
    document.body.classList.add('drawer-open');
  }

  function unlockBody() {
    document.body.classList.remove('drawer-open');
    document.body.style.top = '';
    window.scrollTo(0, savedScrollY);
  }

  function openDrawer(name, trigger) {
    var drawer = drawers[name];
    if (!drawer) return;

    // Switching from one drawer to another: close the current one but
    // keep the scroll lock in place so the page doesn't flicker/jump.
    var wasOpen = !!openName;
    if (openName && openName !== name) {
      closeDrawer({ restoreFocus: false, keepLock: true });
    }

    openName = name;
    lastTrigger = trigger || document.activeElement;

    overlay.classList.add('active');
    drawer.setAttribute('aria-hidden', 'false');

    // Only lock on the first open; do nothing if we're mid-switch.
    if (!wasOpen) lockBody();

    if (lastTrigger && lastTrigger.setAttribute) {
      lastTrigger.setAttribute('aria-expanded', 'true');
    }

    // Move focus after the slide has started so the first item is visible
    setTimeout(function () {
      var focusables = getFocusable(drawer);
      if (focusables.length) focusables[0].focus();
      else drawer.focus();
    }, 60);
  }

  function closeDrawer(opts) {
    opts = opts || {};
    if (!openName) return;
    var drawer = drawers[openName];
    var trigger = lastTrigger;

    drawer.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('active');

    // Skip unlock when the caller is immediately going to reopen another
    // drawer (drawer-to-drawer switch). Otherwise restore scroll position.
    if (!opts.keepLock) unlockBody();

    if (trigger && trigger.setAttribute) {
      trigger.setAttribute('aria-expanded', 'false');
      if (opts.restoreFocus !== false) {
        try { trigger.focus(); } catch (e) { /* noop */ }
      }
    }

    openName = null;
    lastTrigger = null;
  }

  // Click-through: open triggers, close triggers, overlay click
  document.addEventListener('click', function (e) {
    var opener = e.target.closest && e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(opener.getAttribute('data-drawer-open'), opener);
      return;
    }
    var closer = e.target.closest && e.target.closest('[data-drawer-close]');
    if (closer) {
      e.preventDefault();
      closeDrawer();
      return;
    }
    if (e.target === overlay) {
      closeDrawer();
    }
  });

  // Keyboard: Escape closes, Tab cycles focus
  document.addEventListener('keydown', function (e) {
    if (!openName) return;

    if (e.key === 'Escape') {
      e.preventDefault();
      closeDrawer();
      return;
    }

    if (e.key === 'Tab') {
      var drawer = drawers[openName];
      var focusables = getFocusable(drawer);
      if (!focusables.length) {
        e.preventDefault();
        drawer.focus();
        return;
      }
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });
})();
